exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li[data-v-b854828c]:hover {\n  -webkit-transition: all 250ms ease;\n  transition: all 250ms ease;\n  -webkit-transform: scale(1.05);\n          transform: scale(1.05);\n}", ""]);

// exports
